import React, { Component } from 'react'
import Button from 'components/Button'
import { Field } from 'redux-form'
import Radio from 'components/Input/Radio'
import BillingCreditCardRow from 'features/Billing/BillingCreditCardRow'
import BillingBankAccountRow from 'features/Billing/BillingBankAccountRow'
import { vRequired } from 'components/Input/Input.validations'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'
import sText from 'components/Text/Text.scss'

export default class BillingAccountFormPaymentStep extends Component {
  render() {
    const { prev, loading, billingAccount, directDebitMethod } = this.props

    return (
      <div>
        <div className={cn(sText.descrip1, sMarg.mt60, sMarg.mb30)}>3. Payment</div>
        <Field
          label="Credit Card"
          component={Radio}
          name="directDebitMethod"
          radioValue="Credit Card"
          style={{ marginBottom: '15px' }}
          validate={[vRequired]}
        />
        <Field
          label="Bank Account"
          component={Radio}
          name="directDebitMethod"
          radioValue="Bank Account"
          style={{ marginBottom: '15px' }}
          validate={[vRequired]}
        />

        {directDebitMethod === 'Credit Card' ? (
          <BillingCreditCardRow billingAccount={billingAccount} />
        ) : null}

        {directDebitMethod === 'Bank Account' ? (
          <BillingBankAccountRow billingAccount={billingAccount} />
        ) : null}

        {prev && (
          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
            style={{ marginTop: '40px' }}
          >
            <Button
              color="tertiary"
              type="submit"
              loading={loading}
              disabled={!billingAccount || loading}
            >
              Finish
            </Button>
            <br />
            <br />
            <Button plain onClick={prev}>
              Back
            </Button>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountFormPaymentStep/BillingAccountFormPaymentStep.jsx